export enum JobLogType {
	Undefined = 0,
	Success = 1,
	Fail = 2,
	AmountMismatch = 3,
	Error = 4,
	All = 5,
	Info = 6,
}
